import { memo } from 'preact/compat';

import Header from '@/components/Header';
import PageWrapper from '@/components/Main/PageWrapper';

import Schedule from '../schedule';
import style from './style.scss';

const TalkSchedule = () => (
  <div className={style.body}>
    <Header />
    <PageWrapper>
      <Schedule />
    </PageWrapper>
  </div>
);

export default memo(TalkSchedule);
